// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"ConfirmEmail_thankYouMessage__v69rG","button":"ConfirmEmail_button__S73Z8"};